import { n as E, i as B, a as C, t as w, b as _, c as k, d as I } from "./index-9FD4Wxfy.mjs";
import { watch as R, computed as M, ref as O, getCurrentInstance as L, onMounted as W } from "vue";
const A = C ? window : void 0;
function m(e) {
  var t;
  const r = w(e);
  return (t = r == null ? void 0 : r.$el) != null ? t : r;
}
function g(...e) {
  let t, r, s, d;
  if (typeof e[0] == "string" || Array.isArray(e[0]) ? ([r, s, d] = e, t = A) : [t, r, s, d] = e, !t)
    return E;
  Array.isArray(r) || (r = [r]), Array.isArray(s) || (s = [s]);
  const f = [], a = () => {
    f.forEach((l) => l()), f.length = 0;
  }, c = (l, n, i, p) => (l.addEventListener(n, i, p), () => l.removeEventListener(n, i, p)), v = R(
    () => [m(t), w(d)],
    ([l, n]) => {
      if (a(), !l)
        return;
      const i = _(n) ? { ...n } : n;
      f.push(
        ...r.flatMap((p) => s.map((y) => c(l, p, y, i)))
      );
    },
    { immediate: !0, flush: "post" }
  ), b = () => {
    v(), a();
  };
  return k(b), b;
}
let P = !1;
function N(e, t, r = {}) {
  const { window: s = A, ignore: d = [], capture: f = !0, detectIframe: a = !1 } = r;
  if (!s)
    return E;
  B && !P && (P = !0, Array.from(s.document.body.children).forEach((o) => o.addEventListener("click", E)), s.document.documentElement.addEventListener("click", E));
  let c = !0;
  const v = (o) => w(d).some((u) => {
    if (typeof u == "string")
      return Array.from(s.document.querySelectorAll(u)).some((h) => h === o.target || o.composedPath().includes(h));
    {
      const h = m(u);
      return h && (o.target === h || o.composedPath().includes(h));
    }
  });
  function b(o) {
    const u = w(o);
    return u && u.$.subTree.shapeFlag === 16;
  }
  function l(o, u) {
    const h = w(o), x = h.$.subTree && h.$.subTree.children;
    return x == null || !Array.isArray(x) ? !1 : x.some((S) => S.el === u.target || u.composedPath().includes(S.el));
  }
  const n = (o) => {
    const u = m(e);
    if (o.target != null && !(!(u instanceof Element) && b(e) && l(e, o)) && !(!u || u === o.target || o.composedPath().includes(u))) {
      if (o.detail === 0 && (c = !v(o)), !c) {
        c = !0;
        return;
      }
      t(o);
    }
  };
  let i = !1;
  const p = [
    g(s, "click", (o) => {
      i || (i = !0, setTimeout(() => {
        i = !1;
      }, 0), n(o));
    }, { passive: !0, capture: f }),
    g(s, "pointerdown", (o) => {
      const u = m(e);
      c = !v(o) && !!(u && !o.composedPath().includes(u));
    }, { passive: !0 }),
    a && g(s, "blur", (o) => {
      setTimeout(() => {
        var u;
        const h = m(e);
        ((u = s.document.activeElement) == null ? void 0 : u.tagName) === "IFRAME" && !(h != null && h.contains(s.document.activeElement)) && t(o);
      }, 0);
    })
  ].filter(Boolean);
  return () => p.forEach((o) => o());
}
function T(e) {
  return typeof e == "function" ? e : typeof e == "string" ? (t) => t.key === e : Array.isArray(e) ? (t) => e.includes(t.key) : () => !0;
}
function V(...e) {
  let t, r, s = {};
  e.length === 3 ? (t = e[0], r = e[1], s = e[2]) : e.length === 2 ? typeof e[1] == "object" ? (t = !0, r = e[0], s = e[1]) : (t = e[0], r = e[1]) : (t = !0, r = e[0]);
  const {
    target: d = A,
    eventName: f = "keydown",
    passive: a = !1,
    dedupe: c = !1
  } = s, v = T(t);
  return g(d, f, (l) => {
    l.repeat && w(c) || v(l) && r(l);
  }, a);
}
function $() {
  const e = O(!1), t = L();
  return t && W(() => {
    e.value = !0;
  }, t), e;
}
function z(e) {
  const t = $();
  return M(() => (t.value, !!e()));
}
function j(e, t, r = {}) {
  const { window: s = A, ...d } = r;
  let f;
  const a = z(() => s && "ResizeObserver" in s), c = () => {
    f && (f.disconnect(), f = void 0);
  }, v = M(() => {
    const n = w(e);
    return Array.isArray(n) ? n.map((i) => m(i)) : [m(n)];
  }), b = R(
    v,
    (n) => {
      if (c(), a.value && s) {
        f = new ResizeObserver(t);
        for (const i of n)
          i && f.observe(i, d);
      }
    },
    { immediate: !0, flush: "post" }
  ), l = () => {
    c(), b();
  };
  return k(l), {
    isSupported: a,
    stop: l
  };
}
function q(e, t = { width: 0, height: 0 }, r = {}) {
  const { window: s = A, box: d = "content-box" } = r, f = M(() => {
    var n, i;
    return (i = (n = m(e)) == null ? void 0 : n.namespaceURI) == null ? void 0 : i.includes("svg");
  }), a = O(t.width), c = O(t.height), { stop: v } = j(
    e,
    ([n]) => {
      const i = d === "border-box" ? n.borderBoxSize : d === "content-box" ? n.contentBoxSize : n.devicePixelContentBoxSize;
      if (s && f.value) {
        const p = m(e);
        if (p) {
          const y = p.getBoundingClientRect();
          a.value = y.width, c.value = y.height;
        }
      } else if (i) {
        const p = Array.isArray(i) ? i : [i];
        a.value = p.reduce((y, { inlineSize: o }) => y + o, 0), c.value = p.reduce((y, { blockSize: o }) => y + o, 0);
      } else
        a.value = n.contentRect.width, c.value = n.contentRect.height;
    },
    r
  );
  I(() => {
    const n = m(e);
    n && (a.value = "offsetWidth" in n ? n.offsetWidth : t.width, c.value = "offsetHeight" in n ? n.offsetHeight : t.height);
  });
  const b = R(
    () => m(e),
    (n) => {
      a.value = n ? t.width : 0, c.value = n ? t.height : 0;
    }
  );
  function l() {
    v(), b();
  }
  return {
    width: a,
    height: c,
    stop: l
  };
}
export {
  N as a,
  V as o,
  q as u
};
//# sourceMappingURL=index-BTmZbsz8.mjs.map
